import {setlog} from "@modules/58m"
export default (msg)=>{
    msg.forEach((item)=>{
        let {isUser,logActionType,opts={}} = item;
        //目前只有chatbot返回信息 需要埋点
        if(!isUser){
            if(logActionType){//logActionType 前端匹配的才会有
                setlog(logActionType,opts)
            }
            if(item.type==2){
                setlog("mchatbot_joblist_show");
            }
        }
    })

    
}